import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'

import { changelogModalShow, feedbackModalShow, myAccountModalShow, settingsModalShow } from 'Global/Stores/modals'
import { signOut } from 'Global/Stores/auth'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    showChangelogModal: () => dispatch(changelogModalShow()),
    showFeedbackModal: () => dispatch(feedbackModalShow()),
    showMyAccountModal: () => dispatch(myAccountModalShow()),
    showSettingsModal: () => dispatch(settingsModalShow()),
    signOut: () => dispatch(signOut()),
  })

  Enhancer.displayName = 'TopbarEnhancer'

  Enhancer.propTypes = {
    showChangelogModal: PropTypes.func.isRequired,
    showFeedbackModal: PropTypes.func.isRequired,
    showMyAccountModal: PropTypes.func.isRequired,
    showSettingsModal: PropTypes.func.isRequired,
    signOut: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
